const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * User Tracks Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('UserTracks', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/user-tracks/:subresource/:complete/:type/:contentId', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    filter: {params: {subresource: 'filter'}, method: 'GET', isArray: true},
    manualComplete: {params: {complete: 'manual-complete'}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    lastview: {params: {subresource: '', complete: 'lastview', contentId: ''}, method: 'POST', isArray: false},
    complete: {params: {subresource: '', complete: 'complete', type: '', contentId: ''}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });

}]);



